<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card class="elevation-12">
          <v-toolbar color="blue darken-1" dark flat>
            <v-toolbar-title>Вход в систему</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="username"
                label="Логин"
                name="login"
                prepend-icon="person"
                type="text"
                @keydown.enter="submit()"
              ></v-text-field>

              <v-text-field
                v-model="password"
                label="Пароль"
                name="password"
                prepend-icon="lock"
                type="password"
                @keydown.enter="submit()"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn name="submit" color="success" @click="submit()">Войти</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      username: '',
      password: '',
    }
  },
  methods: {
    submit() {
      this.LOGIN(this).then(
        () => {
          this.$toast.fire({
            icon: 'success',
            title: 'Успешнный вход',
          })
          this.$router.push('/')
        },
        () => {
          this.$toast.fire({
            icon: 'error',
            title: 'Ошибка входа',
          })
        },
      )
    },
    ...mapActions('auth', ['LOGIN']),
  },
}
</script>
